import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

`;

export const ContainerDivs = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;

    @media(max-width: 768px) {
        padding: 0;
    }
`;

export const ContainerStudent = styled.div`
    width: 95%;
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: 1000px;
    padding: 10px;
    gap: 15px;
    border-radius: 5px;
    background-color: var(--surface);

    @media(max-width: 768px) {
        padding: 5px;
    }
`;

export const DataSelected = styled.div`
    width: 100%;
`;

export const DivButton = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 20px;

    @media(max-width: 768px) {
        align-items: center;
    }
`;

export const List = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 20px;
`;

export const ListChecked = styled.div`
    border-top: 2px solid var(--green); /* Borda da lista */
    margin: 20px 0;
    width: 100%;
    padding: 10px;
    position: relative; /* Necessário para o título */
    
    &:before {
        content: 'Chamadas Finalizadas'; /* Texto da borda */
        position: absolute;
        top: -15px; /* Ajuste conforme necessário */
        left: 50%;
        transform: translateX(-50%); /* Centraliza o texto */
        background: var(--surface); /* Fundo para que o texto não fique atrás da borda */
        padding: 0 3px; /* Espaçamento lateral */
        font-weight: bold; /* Negrito para destaque */
        color: var(--text-muted); /* Cor do texto */

        @media (max-width: 345px)  {
            font-size: 13px; /* Smartphones pequenos */
        }
        @media (min-width: 345px) {
            font-size: 10pt; /* Smartphones pequenos */
        }

        @media (min-width: 481px) and (max-width: 768px) {
            font-size: 11pt; /* Tablets */
        }
    }
`;


export const Emp = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 30px;
    gap: 15px;
    min-width: 90%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    @media(max-width: 768px) {
        width: 100%;
        gap: 2px;
        margin-bottom: 25px;
        padding: 0;
    }
`;

export const EmpEdit = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 35px;
    gap: 15px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    @media(max-width: 768px) {
        width: 100%;
        gap: 2px;
        padding: 0;
    }
`;

export const DivInfo = styled.div`
    background-color: var(--surface);
    width: 90%;
    max-width: 600px;
    padding: 20px;
    padding-top: 40px;
    padding-bottom: 40px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    h3 {
        text-align: center;
        padding-bottom: 30px;
    }
`;

export const DivInfoDate = styled.div`
    background-color: var(--teal-text, var(--teal));
    width: 90%;
    max-width: 600px;
    padding: 20px;
    padding-top: 40px;
    padding-bottom: 40px;
    gap: 30px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    h3 {
        text-align: center;
        padding-bottom: 30px;
        color: white;
    }
`;

export const Span = styled.button`
    border: none;
    font-size: 16px;
    color: var(--text, var(--text-muted));

    @media (max-width: 375px)  {
        width: 90%;
      font-size: 9pt; /* Smartphones pequenos */
      padding: 0;
    }
    @media (min-width: 375px) and (max-width: 768px) {
        width: 90%;
      font-size: 10pt; /* Smartphones pequenos */
      padding: 0;
    }
`;

export const SpanChecked = styled.button`
    display: flex;
    align-items: center;
    gap: 20px;
    border: none;
    font-size: 16px;
    color: var(--text, var(--text-muted));

    @media (max-width: 375px)  {
      font-size: 9pt; /* Smartphones pequenos */
      padding: 0;
    }
    @media (min-width: 375px) and (max-width: 768px) {
      font-size: 10pt; /* Smartphones pequenos */
      padding: 0;
    }
`;

export const Btt02 = styled.button`
    padding: 10px;
    background-color: var(--teal-text, var(--teal));
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #0056b3;
    }

    @media (max-width: 375px)  {
      font-size: 8pt; /* Smartphones pequenos */
      padding: 6px;
    }
    @media (min-width: 375px) and (max-width: 768px) {
      font-size: 9pt; /* Smartphones pequenos */
      padding: 7px;
    }

    @media(min-width: 600px) {
        padding: 10px;
    }
`;

export const SelectorContainer = styled.div`
    margin-bottom: 20px;
`;

export const EditContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 30px;

    h3 {
        text-align: center;
    }

    select {
        width: 80%;
        max-width: 400px;
        padding: 10px;
        font-size: 16px;
        border: 1px solid var(--line);
        border-radius: 5px;
    }
`;

// Componente para a lista de chamada
export const AttendanceList = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
    margin-top: 20px;
`;

export const AttendanceItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-radius: 5px;
    background-color: ${props => (props.checked ? 'var(--green-soft)' : 'var(--red-soft)')};
    transition: background-color 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;

    &:hover {
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    }
`;

export const AttendanceButton = styled.button`
    padding: 5px 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &.present {
        background-color: #28a745; /* Verde para presença */
        color: white;

        &:hover {
            background-color: #218838; /* Escuro para presença */
        }
    }

    &.absent {
        background-color: #dc3545; /* Vermelho para ausência */
        color: white;

        &:hover {
            background-color: #c82333; /* Escuro para ausência */
        }
    }
`;

export const BoxButton = styled.div`
    display: flex;
    gap: 50px;
    justify-content: space-between;

    label {
        @media (min-width: 1024px) {
            font-size: 17px;

            input {
                width: 20px;
                height: 20px;
            }
        }
    }


    @media(max-width: 768px) {
        gap: 5px;
    }
`;

export const BoxButtonEdit = styled.div`
    display: flex;
    gap: 100px;
    justify-content: space-between;
`;

export const BoxButtonStatus = styled.div`
    display: flex;
    padding: 20px;
    gap: 20px;
`;